import { render } from "./InternalTransfer.vue?vue&type=template&id=20c6c4a6&scoped=true"
import script from "./InternalTransfer.vue?vue&type=script&lang=js"
export * from "./InternalTransfer.vue?vue&type=script&lang=js"

import "./InternalTransfer.vue?vue&type=style&index=0&id=20c6c4a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c6c4a6"]])

export default __exports__